import React from 'react';
import { Box, Text, Image, Swatches, Button } from '@wix/design-system';
import s from './BrandkitPreview.scss';
import { format } from 'date-fns';
export const BrandkitPreview = _ref => {
  var _brandkit$colors;
  let {
    brandkit,
    send,
    onAction,
    selectedButton,
    isCompleted
  } = _ref;
  const dateFormatted = brandkit != null && brandkit.updatedDate ? format(new Date(brandkit.updatedDate), 'MMMM d, yyyy') : '';
  const handleSelectClick = () => {
    onAction({
      buttonName: selectedButton.buttonName,
      sideEffectName: selectedButton.sideEffectName,
      brandkit
    });
    send(`${selectedButton.respondText} ${brandkit == null ? void 0 : brandkit.name}` || 'brandkit selected');
  };
  return /*#__PURE__*/React.createElement(Box, {
    paddingLeft: "SP3",
    paddingRight: "SP3",
    height: "60px",
    direction: "horizontal",
    gap: "SP3",
    verticalAlign: "middle",
    className: s.card,
    align: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "40%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    ellipsis: true,
    skin: isCompleted ? 'disabled' : undefined
  }, brandkit == null ? void 0 : brandkit.name), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    ellipsis: true,
    skin: isCompleted ? 'disabled' : undefined
  }, `Update on ${dateFormatted}`)), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "SP2"
  }, brandkit != null && brandkit.logo ? /*#__PURE__*/React.createElement(Image, {
    showBorder: true,
    src: brandkit.logo,
    width: 48,
    height: 30,
    fit: "contain",
    transparent: true
  }) : /*#__PURE__*/React.createElement(Box, {
    width: 48,
    height: 30
  }), /*#__PURE__*/React.createElement(Swatches, {
    size: "small",
    gap: 1,
    colors: brandkit == null || (_brandkit$colors = brandkit.colors) == null ? void 0 : _brandkit$colors.slice(0, 6).filter(color => Boolean(color))
  })), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: handleSelectClick,
    disabled: isCompleted
  }, selectedButton.label));
};
//# sourceMappingURL=BrandkitPreview.js.map